
// import 'vuetify/styles'
// import { createVuetify } from 'vuetify'
// import { aliases, mdi } from 'vuetify/iconsets/mdi'

// export default createVuetify({
//   icons: {
//     defaultSet: 'mdi',
//     aliases,
//     sets: {
//       mdi,
//     },
//   },
//   theme: {
//     defaultTheme: 'light',
//   },
// })
// src/plugins/vuetify.js
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  components,   // ✅ register all Vuetify components
  directives,   // ✅ register directives like v-ripple, v-scroll, etc.
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    customTheme: {
        colors: {
          primary: '#1976D2', // Vuetify default primary
          secondary: '#424242',
          accent: '#82B1FF',
          iconColor: '#FF5733', // Custom color for icons
          outlineColor: '#4CAF50', // Custom color for outlined field borders
        },
      },
  },
  
})


